import { Building02 } from '@untitledui/icons'

import { useDesktopNavigation } from '@components/navbar/desktop/DesktopNavigationContext'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { routesFactory } from '@utils/routes.ts'

import NavItem from './NavItem'

function StoreManagementNavItem() {
  const { t } = useTypedTranslation()
  const { storeId, scanId, user, isActive } = useDesktopNavigation()

  const isMinStoreManager = user.hasAnyRoleForStore(storeId, ['STORE_MANAGER'])

  if (!isMinStoreManager) return null

  return (
    <NavItem
      to={routesFactory.storeManagement(storeId, scanId)}
      label={t('storeManagement.title')}
      isActive={isActive('store-management')}
      icon={<Building02 size={20}/>}
    />
  )
}

export default StoreManagementNavItem

